import React from 'react';

export default function TemplatesIcon({
  size = 24,
  stroke = '#666666',
  strokeWidth = 2,
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3.75 2.75C3.75 1.92157 4.42157 1.25 5.25 1.25H11.6213C12.0191 1.25 12.4006 1.40804 12.6819 1.68934L15.5607 4.56808C15.842 4.84938 16 5.23087 16 5.62868V16.25C16 17.0784 15.3284 17.75 14.5 17.75H5.25C4.42157 17.75 3.75 17.0784 3.75 16.25V2.75Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 1.75V5.25C11.5 5.94036 12.0596 6.5 12.75 6.5H16.25"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10H13"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M7 13.5H13"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
